import React from 'react';
import { Modal } from 'react-bootstrap';

interface Props {
  showModal: boolean;
  body: JSX.Element;
  closeModal: () => void;
}

const CrystalModal = (props: Props) => {
  const { showModal, body, closeModal } = props;
  return (
    <div id='crsytalmodal-wrapper'>
      <Modal
        id='crsytalmodal-modal'
        show={showModal}
        onHide={closeModal}
        keyboard={false}
        centered
        dialogClassName="crystal_modal"
      >
        <Modal.Body id={`crsytalmodal-body-${body}`}>{body}</Modal.Body>
      </Modal>
    </div>
  );
};

export default CrystalModal;
